export const getTaxCategories = (translate: (key: string) => string) => [
  { label: translate("VAT_label"), value: "VAT" },
  { label: translate("IGIC_label"), value: "IGIC" },
  { label: translate("IRPF_label"), value: "IRPF" },
  { label: translate("WHT_label"), value: "WHT" },
];

export const getTaxesTableHead = (translate: (key: string) => string) => [
  { id: "code", label: translate("code"), align: "left" },
  { id: "description", label: translate("description"), align: "left" },
  { id: "taxType", label: translate("tax_type"), align: "left" },
  { id: "rate", label: translate("rate"), align: "left" },
  { id: "isWithholdingTax", label: translate("withholding"), align: "left" },
  { id: "actions", label: translate("actions"), align: "left" },
];

export const COMPLIANCE_STANDARD_MAP: Record<string, number> = {
  VeriFactu: 0,
  SII: 1,
  SDI: 2,
  FrancePA: 3,
};

export const COMPLIANCE_STANDARD_REVERSE_MAP: Record<number, string> = {
  0: "VeriFactu",
  1: "SII",
  2: "SDI",
  3: "FrancePA",
};

export const COMPLIANCE_OPTIONS = [null, "VeriFactu", "SII", "SDI", "FrancePA"] as const;
